export default "__VITE_ASSET__BA6Qt66m__";